module.exports = __webpack_public_path__ + "band_12.d3625c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_12.png
// module id = ETel
// module chunks = 0